import _ from 'lodash'
import type {FunctionPropertyTypeMetadata} from '../../../../../metadata'
import type {Repeat, RepeatType} from '@wix/document-services-types'
import type {CssValue} from '../../constants'
import {deserializeFunction, serializeFunction} from '../utils/function'
import {asArray} from '@wix/document-manager-utils'

const REPEAT_TYPE: RepeatType = 'Repeat'
const REPEAT_FUNCTION_NAME: string = 'repeat'

const serialize = (
    val: any,
    {argsMetadata}: FunctionPropertyTypeMetadata,
    serializeValue: Function
): CssValue | undefined => {
    if (!_.isPlainObject(val)) {
        return undefined
    }

    const {type, length, value} = val

    if (type !== REPEAT_TYPE || !length || !value) {
        return undefined
    }

    const serializedLength = serializeValue(length, argsMetadata.length.types)
    const serializedValue = serializeValue(value, argsMetadata.value.types)

    return serializeFunction({name: REPEAT_FUNCTION_NAME, args: [serializedLength, ...asArray(serializedValue)]})
}

const deserialize = (
    rule: CssValue,
    {argsMetadata}: FunctionPropertyTypeMetadata,
    deserializeValue: Function
): Repeat | undefined => {
    const func = deserializeFunction(rule)
    if (!func) {
        return undefined
    }

    const {name, args} = func

    if (name !== REPEAT_FUNCTION_NAME || args.length < 2) {
        return undefined
    }

    const [length, value] = args

    const deserializedLength = deserializeValue(length, argsMetadata.length.types)
    const deserializedValue = deserializeValue(value, argsMetadata.value.types)

    return {
        type: REPEAT_TYPE,
        length: deserializedLength,
        value: deserializedValue
    }
}

export default {
    serialize,
    deserialize
}
